import { get, put, post, postWithParams, del, constructURL } from "./httpclient";

// resolve the url with path param
const resolve = (url, params = {}) => {
	return url.replace(/\{(\w+)\}/g, (g0, g1) => {
		const value = params[g1];

		delete params[g1];
		return value;
	});
};

export default class {
	constructor(url) {
		this.url = url;
	}

	get(params = {}, respType = null, showToast = false) {
		const _params = Object.assign({}, params);
		const _url = resolve(this.url, _params);
		return get({ url: _url, params: _params }, respType, showToast);
	}

	put(data, params = {}, showToast = false) {
		const _params = Object.assign({}, params);
		const _url = resolve(this.url, _params);
		return put({ url: _url, data, params: _params }, showToast);
	}

	post(data, params = {}, showToast = false) {
		const _params = Object.assign({}, params);
		const _url = resolve(this.url, _params);
		return post({ url: _url, data, params: _params }, showToast);
	}

	postWithParams(data, params = {}, showToast = false) {
		const _params = Object.assign({}, params);
		const _url = resolve(this.url, _params);
		return postWithParams({ url: _url, data, params: _params }, showToast);
	}

	del(data, params = {}, showToast = false) {
		const _params = Object.assign({}, params);
		const _url = resolve(this.url, _params);
		return del({ url: _url, data, params: _params }, showToast);
	}

	constructFullURL(partialURL) {
		return constructURL(partialURL);
	}
}
